import React from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
} from 'reactstrap';

import Grid from '../../components/cms/grid';
import AddNewButton from '../../components/cms/grid/addNewButton';
import ModelService from '../../services/menu.service';
import getColumns from './getColumns';

const initCriteria = {
  id: '',
  title: '',
  status: '',
  position: '',
  priority: '',
  sortBy: 'priority',
  order: 'asc',
  parent_id: 'null',
};

const permissionToDelete = ['delete_menus'];
const permissionToCreate = ['create_menus'];

const Menus = ({ t }) => (
  <div className="">
    <Row>
      <Col xl={12}>
        <Card>
          <CardHeader>
            <strong><i className="fa fa-list" /> {t('Menus')}</strong>
          </CardHeader>
          <CardBody>
            <div className="pull-right mb-1">
              <AddNewButton
                to={ModelService.getCreateUrl()}
                permissionToCreate={permissionToCreate}
              />
            </div>
            <Grid
              id="menus"
              service={ModelService}
              columns={getColumns(t)}
              initCriteria={initCriteria}
              permissionToDelete={permissionToDelete}
            />
          </CardBody>
        </Card>
      </Col>
    </Row>
  </div>
);

Menus.propTypes = {
  t: PropTypes.func.isRequired,
};

export default Menus;



// WEBPACK FOOTER //
// ./src/views/menus/Menus.jsx